import cls from 'classnames';
import { Skeleton } from '@picsart/design-system/components/Skeleton';
import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import useStyles from './styles';
import useSkeletonStyles from './skeletonStyles';
import { WidgetExperimentSkeletonProps } from './types';

function FallBack({ isBannerBlockWidget }: WidgetExperimentSkeletonProps) {
  const classes = useStyles();
  const skeleton = useSkeletonStyles({ isBannerBlockWidget });

  return (
    <HorizontalContainer dataTestId="fallback">
      <Skeleton borderRadius={CornerRadius.r8} className={cls(classes.title, skeleton.title)} />
      <Skeleton
        borderRadius={CornerRadius.r8}
        className={cls(classes.description, skeleton.description)}
      />
      <Skeleton borderRadius={CornerRadius.r8} className={skeleton.widget} />
      <Skeleton borderRadius={CornerRadius.r8} className={skeleton.rating} />
      <Skeleton borderRadius={CornerRadius.r8} className={skeleton.img} />
    </HorizontalContainer>
  );
}

export default FallBack;
